import Swiper from 'swiper';

const Sliders = () => {

    // Home big slider
    const smallTopSlider = new Swiper('.big-slider__container', {
        slidesPerView: 1,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        loop: true,
        autoplay: {
            delay: 5000,
        },
    });

    // white slider
    const whiteSlider = new Swiper('.white-slider__wrapper-container', {
        slidesPerView: 1,
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        loop: true,
        autoplay: {
            delay: 5000,
        },
    });


    // Grid slider module
    const gridSlider = new Swiper('.grid-slider__wrapper-container', {
        slidesPerView: 1,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        loop: true,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            575: {
              slidesPerView: 2,
            },
            // when window width is >= 640px
            1024: {
              slidesPerView: 3,
            }
          }
    });

}

export default Sliders;